import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import IconYouTube from '../../../components/icons/icon-youtube';
import MaterialSymbol from '../../../components/icons/material-symbol';
import YTShorts from '../../../assets/images/yt-shorts.png';

type Props = {
  data: { [tabName: string]: any[] };
  title: string;
  ytShorts?: boolean;
  fetchData: (tab: string, page: number) => void;
  resetTrigger?: any; // 👈 add this to listen for changes (e.g., timeRangePost)
};

const VideoSection: React.FC<Props> = ({ data, title, ytShorts, fetchData, resetTrigger }) => {
  const tabKeys = ['top', 'paid', 'organic', 'recent']; // API keys
  
  const availableTabs = tabKeys.filter((tab) => data?.[tab]?.length > 0);
  const [activeTab, setActiveTab] = useState(availableTabs[0] || '');
  const [page, setPage] = useState<{ [key: string]: number }>({});
  const [loadingTabs, setLoadingTabs] = useState<{ [key: string]: boolean }>({});
  const sliderRef = useRef<Slider | null>(null);

  // ✅ Reset all pages when resetTrigger changes
  useEffect(() => {
    const resetPages = tabKeys.reduce((acc, tab) => {
      acc[tab] = 1;
      return acc;
    }, {} as { [key: string]: number });

    setPage(resetPages);

    // Also reload active tab data
    loadTabData(activeTab, 1);

    // Reset slider position
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0);
    }
  }, [resetTrigger]); // 👈 fires when the parent filter changes
  useEffect(() => {
    if (!availableTabs.includes(activeTab)) {
      setActiveTab(availableTabs[0] || '');
    }
  }, [data]);
  // Load data when tab changes
  useEffect(() => {
    if (!data[activeTab]) {
      loadTabData(activeTab, 1);
    }
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0);
    }
  }, [activeTab]);

  const loadTabData = async (tab: string, pageNum: number) => {
    setLoadingTabs(prev => ({ ...prev, [tab]: true }));
    await fetchData(tab, pageNum);
    setLoadingTabs(prev => ({ ...prev, [tab]: false }));
  };

  const handleAfterChange = (currentSlide: number) => {
    const currentData = data[activeTab] || [];
    const totalSlides = currentData.length;
    const slidesToShow = 5.5;

    if (
      !loadingTabs[activeTab] &&
      totalSlides > 0 &&
      currentSlide >= totalSlides - slidesToShow
    ) {
      const nextPage = (page[activeTab] || 1) + 1;
      setPage(prev => ({ ...prev, [activeTab]: nextPage }));
      loadTabData(activeTab, nextPage);
    }
  };

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5.5,
    slidesToScroll: 1,
    arrows: false,
    swipeToSlide: true,
    afterChange: handleAfterChange,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  const isLoading = loadingTabs[activeTab];

  return (
    <div className="follower-sec follower-sec-grey d-flex flex-column gap-0 w-100">
      <div className="card-follower card-follower-grey flex-column w-100">
        {/* <div className="d-flex w-100">
          <strong className="sec-media-posts__title">{title}</strong>

          <div className="d-flex space-x-2 mb-4 ms-auto gap-2">
            {tabKeys.map(tab => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-3 py-1 rounded-pill fs-14 border ${
                  activeTab === tab ? 'bg-black text-white' : 'bg-gray-100 text-black'
                }`}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>
          <div className="d-flex flex-wrap justify-content-end gap-2 mb-4">
            {tabKeys.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-3 py-1 rounded-pill fs-14 border ${
                  activeTab === tab ? 'bg-black text-white' : 'bg-gray-100 text-black'
                }`}
                style={{ flex: '0 1 auto' }}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>

        </div> */}

        {/* <div className="d-flex align-items-center w-100 mb-4">
          <strong className="sec-media-posts__title">{title}</strong>
          <div className="d-flex flex-wrap gap-2 ms-auto">
            {tabKeys.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-3 py-1 rounded-pill fs-14 border ${
                  activeTab === tab ? 'bg-black text-white' : 'bg-gray-100 text-black'
                }`}
                style={{ flex: '0 1 auto' }}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>
        </div> */}

        <div className="d-flex align-items-center flex-wrap w-100 mb-4">
  {/* Title on the left */}
  <strong className="sec-media-posts__title">{title}</strong>

  {/* Tabs on the right (or below on small screens) */}
  <div className="d-flex flex-wrap gap-2 ms-auto mt-2 mt-sm-0">
    {/* {tabKeys.map((tab) => (
      <button
        key={tab}
        onClick={() => setActiveTab(tab)}
        className={`px-3 py-1 rounded-pill fs-14 border ${
          activeTab === tab ? 'bg-black text-white' : 'bg-gray-100 text-black'
        }`}
        style={{ flex: '0 1 auto' }}
      >
        {tab.charAt(0).toUpperCase() + tab.slice(1)}
      </button>
    ))} */}
    {availableTabs.map((tab) => (
    <button
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`px-3 py-1 rounded-pill fs-14 border ${
        activeTab === tab ? 'bg-black text-white' : 'bg-gray-100 text-black'
      }`}
    >
      {tab.charAt(0).toUpperCase() + tab.slice(1)}
    </button>))}
  </div>
</div>



        <div style={{ maxWidth: '100%', width: '100%' }}>
          {!data[activeTab]?.length && isLoading ? (
            <div className="text-center py-5">Loading...</div>
          ) : (
            <Slider key={activeTab} ref={sliderRef} {...sliderSettings}>
              {data[activeTab]?.map((item: any, idx: number) => {
                let thumbnail = '';
                try {
                  thumbnail = JSON.parse(item.thumbnails)?.high?.url || '';
                } catch {
                  thumbnail = '';
                }

                return (
                  <div key={item.video_id || idx} className="yt-video-container">
                    <a
                      href={
                        ytShorts
                          ? `https://www.youtube.com/shorts/${item.video_id}`
                          : `https://www.youtube.com/watch?v=${item.video_id}`
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      <img
                        src={thumbnail}
                        alt=""
                        className="w-100 object-cover yt-video-thumb"
                      />
                      <span
                        className={`yt-video-icon ${ytShorts ? 'yt-shorts-icon' : ''}`}
                      >
                        {!ytShorts ? <IconYouTube /> : <img src={YTShorts} alt="" />}
                      </span>
                      <div className="yt-video-info-sec">
                        <div className={`yt-video-info-icon`}>
                          <span className="yt-video-info">
                            <MaterialSymbol iconName="visibility" fontweight="200" />
                            {Number(item.views).toLocaleString()}
                          </span>
                          <span className="yt-video-info">
                            <MaterialSymbol iconName="thumb_up" fontweight="200" />
                            {Number(item.likeCount).toLocaleString()}
                          </span>
                          <span className="yt-video-info">
                            <MaterialSymbol iconName="comment" fontweight="200" />
                            {Number(item.commentCount).toLocaleString()}
                          </span>
                        </div>
                        <span className="yt-video-date">
                          {new Date(item.published_at).toLocaleDateString('en-IN', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })}
                        </span>
                      </div>
                    </a>
                  </div>
                );
              })}

              {isLoading && data[activeTab]?.length > 0 && (
                <div className="yt-video-container text-center d-flex align-items-center justify-content-center">
                  <div className="spinner-border text-dark" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
            </Slider>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoSection;
